const DasherFactoryABI = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_tokenAddress",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "MIN_CHALLENGE_DURATION",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint24",
        internalType: "uint24",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "adminAddress",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "createChallenge",
    inputs: [
      {
        name: "_startingDate",
        type: "uint64",
        internalType: "uint64",
      },
      {
        name: "_totalDuration",
        type: "uint64",
        internalType: "uint64",
      },
      {
        name: "_stakeAmount",
        type: "uint128",
        internalType: "uint128",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "tokenAddress",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "event",
    name: "ChallengeCreated",
    inputs: [
      {
        name: "_creator",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "_challengeContractAddress",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "_startingDate",
        type: "uint64",
        indexed: false,
        internalType: "uint64",
      },
      {
        name: "_totalDuration",
        type: "uint64",
        indexed: false,
        internalType: "uint64",
      },
      {
        name: "_stakeAmount",
        type: "uint128",
        indexed: false,
        internalType: "uint128",
      },
      {
        name: "_timestamp",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "DF__InvalidChallengeDuration",
    inputs: [],
  },
  {
    type: "error",
    name: "DF__InvalidChallengeParams",
    inputs: [],
  },
  {
    type: "error",
    name: "DF__InvalidConfigAddress",
    inputs: [],
  },
  {
    type: "error",
    name: "DF__InvalidStartingDate",
    inputs: [],
  },
  {
    type: "error",
    name: "DF__InvalidTimeConfig",
    inputs: [],
  },
] as const;

export default DasherFactoryABI;
